import React from "react";
import { Flex, Text } from "@chakra-ui/react";
import AppButton from "@/features/line-sheet-sets/app-button";
import CustomIcon from "../../../../../../public/icons-v1_1";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";
import usePathPickSelectionBarHeight from "@/features/pathpick/hooks/usePathPickSelectionBarHeight";
import {
  PATH_PICK_SELECTION_BAR_BOTTOM,
  PATH_PICK_SELECTION_BAR_Z_INDEX,
} from "@/features/pathpick/constants";

interface Props {
  selectedCount: number;
  onClear: () => void;
  onBulkPick: () => void;
}

function PathPickSearchProductsSelectionBar({
  selectedCount,
  onClear,
  onBulkPick,
}: Props) {
  const { t } = useI18nHelper();
  // 바 높이를 실측해 목록 끝 여백(PathPickSelectionBarSpacer)에 넘긴다.
  const rootRef = usePathPickSelectionBarHeight<HTMLDivElement>();

  return (
    <Flex
      ref={rootRef}
      position={"fixed"}
      // 목록 페이지네이션(sticky) 바로 위에 띄운다 — 담은 상품의 선택 바와 같은 자리다.
      bottom={PATH_PICK_SELECTION_BAR_BOTTOM}
      left={"50%"}
      transform={"translateX(-50%)"}
      zIndex={PATH_PICK_SELECTION_BAR_Z_INDEX}
      // 좁은 폭에서는 520px가 화면을 넘으므로 좌우 16px 여백만 남기고 채운다.
      minWidth={{ base: "auto", md: "520px" }}
      width={{ base: "calc(100% - 32px)", md: "auto" }}
      background={"#FFFFFF"}
      border={"0.5px solid #D4D4D1"}
      borderRadius={"12px"}
      boxShadow={"0px 4px 16px rgba(0, 0, 0, 0.16)"}
      padding={{ base: "12px", md: "16px" }}
      gap={{ base: "12px", md: "48px" }}
      justifyContent={"space-between"}
      alignItems={"center"}
    >
      <Flex flexDirection={"column"} gap={"2px"}>
        <Text textStyle={"body-lg-bold"} color={"#444440"}>
          {t("path_pick:search_products.selection_bar.selected_count", {
            count: selectedCount,
          })}
        </Text>
        {/* 좁은 폭에서는 개수와 버튼 두 개를 한 줄에 두려고 설명을 감춘다. */}
        <Text
          textStyle={"body-sm-medium"}
          color={"#8F8F8C"}
          display={{ base: "none", md: "block" }}
        >
          {t("path_pick:search_products.selection_bar.description")}
        </Text>
      </Flex>
      <Flex gap={"8px"} flexShrink={0}>
        <AppButton variant={"white"} onClick={onClear}>
          <Text textStyle={"body-sm-bold"}>
            {t("path_pick:search_products.selection_bar.deselect")}
          </Text>
        </AppButton>
        <AppButton variant={"primary"} onClick={onBulkPick}>
          <Flex gap={"4px"} alignItems={"center"}>
            <CustomIcon
              src={"package"}
              width={16}
              height={16}
              color={"#FFFFFF"}
            />
            <Text textStyle={"body-sm-bold"}>
              {t("path_pick:search_products.selection_bar.bulk_pick")}
            </Text>
          </Flex>
        </AppButton>
      </Flex>
    </Flex>
  );
}

export default PathPickSearchProductsSelectionBar;
